import React from 'react';

export default function AboutUs() {
  return (
    <div className="w-full max-w-3xl mx-auto flex flex-col gap-6 text-gray-300 leading-relaxed font-sans px-2">
      <h1 className="text-4xl font-extrabold bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent mb-2">
        About Us
      </h1>
      
      <section className="flex flex-col gap-4 mt-2">
        <p className="text-sm text-gray-400 leading-relaxed">
          Welcome to <strong className="text-indigo-400">GetQRPost</strong>, the leading privacy-first client-side custom QR generation platform. Our mission is incredibly simple: to provide fast, professional, high-resolution QR codes to businesses and developers around the world, completely free of charge and with zero user profiling.
        </p>
        <p className="text-sm text-gray-400 leading-relaxed">
          Most online generators hide basic custom features behind paywalls, add ugly watermarks to files, show spammy redirect landing pages, or force users to register accounts just to download a single file. Worse, some servers track the Wi-Fi credentials or phone details entered inside generator inputs.
        </p>
        <p className="text-sm text-gray-400 leading-relaxed">
          GetQRPost changes this paradigm. Our generator relies entirely on **client-side compiler technology**. Every byte of data—whether it is a coffee shop guest hotspot, a WhatsApp support inquiry, or a corporate digital portal—is compiled instantly inside your web browser. No personal configurations are ever sent to an external server. Your sensitive network parameters and customer contact information remain 100% yours.
        </p>
      </section>

      <section className="flex flex-col gap-3 mt-4">
        <h2 className="text-xl font-bold text-gray-100">Why GetQRPost?</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="bg-gray-900/40 border border-gray-900 rounded-2xl p-5 flex flex-col gap-2">
            <h3 className="font-bold text-gray-200">100% Anonymous</h3>
            <p className="text-xs text-gray-400">Instant access. No email required, no subscriptions, and zero sign-ups needed.</p>
          </div>
          <div className="bg-gray-900/40 border border-gray-900 rounded-2xl p-5 flex flex-col gap-2">
            <h3 className="font-bold text-gray-200">AdSense & Privacy Safe</h3>
            <p className="text-xs text-gray-400">Sustained by non-intrusive ads. No user tracking profiles, cookies only for tech preferences.</p>
          </div>
          <div className="bg-gray-900/40 border border-gray-900 rounded-2xl p-5 flex flex-col gap-2">
            <h3 className="font-bold text-gray-200">High-Fidelity PNGs</h3>
            <p className="text-xs text-gray-400">Crisp vector compiles. Download high-resolution files ready for print media and menus.</p>
          </div>
          <div className="bg-gray-900/40 border border-gray-900 rounded-2xl p-5 flex flex-col gap-2">
            <h3 className="font-bold text-gray-200">Advanced Design Engine</h3>
            <p className="text-xs text-gray-400">Tweak background and dot shapes, upload custom logos, and maintain total color styling controls.</p>
          </div>
        </div>
      </section>

      <section className="flex flex-col gap-3 border-t border-gray-900 pt-6 mt-4 text-center md:text-left">
        <h2 className="text-lg font-bold text-gray-200">Join Thousands of Businesses</h2>
        <p className="text-sm text-gray-400">
          From neighborhood coffee shops setting up contactless hot-spots to corporate menus and digital marketing flyers, GetQRPost keeps operations quick and secure.
        </p>
      </section>
    </div>
  );
}
